export const DEPRECATED_TERMINAL_TYPE = {
  LIGHTSPEED_P400_PLUS_STRIPE: 'verifone-p400-plus-lightspeed-stripe',
};

export const TERMINAL_TYPE = {
  BLACKLINE: 'Blackline',
  GENIUS_MX915: 'Genius', // Keeping it as Genius for backwards compatibility
  GENIUS_P400: 'verifone-p400-genius',
  GENIUS_E285: 'verifone-e285-genius',
  GENIUS_M400: 'verifone-m400-genius',
  LIGHTSPEED: 'Lightspeed',
  LIGHTSPEED_E285_ADYEN: 'verifone-e285-lightspeed-adyen',
  LIGHTSPEED_M400_ADYEN: 'verifone-m400-lightspeed-adyen',
  LIGHTSPEED_P400_PLUS_ADYEN: 'verifone-p400-plus-lightspeed-adyen',
  LIGHTSPEED_BBPOS_CHIPPER: 'bbpos-chipper-2x-bt-lightspeed-stripe',
  LIGHTSPEED_STRIPE_READER_M2_STRIPE: 'stripe-reader-m2-lightspeed-stripe',
  LIGHTSPEED_BBPOS_WISEPAD_3_STRIPE: 'bbpos-wisepad-3-lightspeed-stripe',
  LIGHTSPEED_BBPOS_WISEPOSE_STRIPE: 'bbpos-wisepose-lightspeed-stripe',
  LIGHTSPEED_STRIPE_READER_S700_STRIPE: 'stripe-reader-s700-lightspeed-stripe',
  LIGHTSPEED_STRIPE_READER_S710_STRIPE: 'stripe-reader-s710-lightspeed-stripe',
  LIGHTSPEED_V400M_ADYEN: 'verifone-v400m-lightspeed-adyen',
  LIGHTSPEED_MX915_VANTIV: 'verifone-mx-915-lightspeed',
  LIGHTSPEED_IPP320_VANTIV: 'ingenico-ipp-320-lightspeed', // for front-end use only; don't send this to the API!
  LIGHTSPEED_ISMP4_VANTIV: 'ingenico-ismp4-lightspeed', // for front-end use only; don't send this to the API!
  TRIPOS: 'TriPOS',
  YOMANI: 'Yomani',
  YOXIMO: 'Yoximo',
  UNKNOWN: 'Unknown',
  ...DEPRECATED_TERMINAL_TYPE,
};

export const isTerminalTypeDeprecated = (
  terminalType?: (typeof TERMINAL_TYPE)[keyof typeof TERMINAL_TYPE]
): boolean => {
  if (!terminalType) {
    return false;
  }
  return Object.values(DEPRECATED_TERMINAL_TYPE).includes(terminalType);
};

export const TERMINAL_PAIRING_METHOD = {
  ACTIVATION_CODE: 'activationCode',
  SERIAL_NUMBER: 'serialNumber',
  BLUETOOTH: 'bluetooth',
  IP_ADDRESS: 'ipAddress',
};
export const TERMINAL_ATTRIBUTES = {
  [TERMINAL_TYPE.GENIUS_MX915]: {
    name: 'Genius MX 915',
    pairingMethod: TERMINAL_PAIRING_METHOD.IP_ADDRESS,
  },
  [TERMINAL_TYPE.GENIUS_P400]: {
    name: 'Genius P400',
    pairingMethod: TERMINAL_PAIRING_METHOD.IP_ADDRESS,
  },
  [TERMINAL_TYPE.GENIUS_E285]: {
    name: 'Genius e285',
    pairingMethod: TERMINAL_PAIRING_METHOD.IP_ADDRESS,
  },
  [TERMINAL_TYPE.GENIUS_M400]: {
    name: 'Genius M400',
    pairingMethod: TERMINAL_PAIRING_METHOD.IP_ADDRESS,
  },
  [TERMINAL_TYPE.LIGHTSPEED]: {
    name: 'Verifone MX 915',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_E285_ADYEN]: {
    name: 'Verifone e285',
    pairingMethod: TERMINAL_PAIRING_METHOD.SERIAL_NUMBER,
  },
  [TERMINAL_TYPE.LIGHTSPEED_M400_ADYEN]: {
    name: 'Verifone M400',
    pairingMethod: TERMINAL_PAIRING_METHOD.SERIAL_NUMBER,
  },
  [TERMINAL_TYPE.LIGHTSPEED_V400M_ADYEN]: {
    name: 'Verifone V400M',
    pairingMethod: TERMINAL_PAIRING_METHOD.SERIAL_NUMBER,
  },
  [TERMINAL_TYPE.LIGHTSPEED_P400_PLUS_ADYEN]: {
    name: 'Verifone P400 Plus',
    pairingMethod: TERMINAL_PAIRING_METHOD.SERIAL_NUMBER,
  },
  [TERMINAL_TYPE.LIGHTSPEED_BBPOS_CHIPPER]: {
    name: 'BBPOS Chipper 2X BT',
    pairingMethod: TERMINAL_PAIRING_METHOD.BLUETOOTH,
  },
  [TERMINAL_TYPE.LIGHTSPEED_BBPOS_WISEPAD_3_STRIPE]: {
    name: 'BBPOS WisePad 3',
    pairingMethod: TERMINAL_PAIRING_METHOD.BLUETOOTH,
  },
  [TERMINAL_TYPE.LIGHTSPEED_STRIPE_READER_M2_STRIPE]: {
    name: 'Stripe Reader M2',
    pairingMethod: TERMINAL_PAIRING_METHOD.BLUETOOTH,
  },
  [TERMINAL_TYPE.LIGHTSPEED_P400_PLUS_STRIPE]: {
    name: 'Verifone P400 Plus',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_BBPOS_WISEPOSE_STRIPE]: {
    name: 'BBPOS WisePOS E',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_STRIPE_READER_S700_STRIPE]: {
    name: 'Stripe Reader S700',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_STRIPE_READER_S710_STRIPE]: {
    name: 'Stripe Reader S710',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_MX915_VANTIV]: {
    name: 'Verifone MX 915',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_IPP320_VANTIV]: {
    name: 'Ingenico IPP320',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
  [TERMINAL_TYPE.LIGHTSPEED_ISMP4_VANTIV]: {
    name: 'Ingenico iSMP4',
    pairingMethod: TERMINAL_PAIRING_METHOD.ACTIVATION_CODE,
  },
};

export default TERMINAL_TYPE;
